import React, { useEffect } from "react";
import Box from "@mui/material/Box";
import { Field, FormSection } from "redux-form";
import Select from "@mui/material/Select";
import Typography from "@mui/material/Typography";
import TextField from "@mui/material/TextField";
import FormControl from "@mui/material/FormControl";
import MenuItem from "@mui/material/MenuItem";
import InputLabel from "@mui/material/InputLabel";
import Grid from "@mui/material/Grid";
import Divider from "@mui/material/Divider";
import DatePickerWrapper from "./date-picker-wrapper.component";
import Autocomplete from "@mui/material/Autocomplete";
import MultiInputChip from "./multi-input-chip-wrapper.component";
import OutlinedInput from "@mui/material/OutlinedInput";
import CloseIcon from "@mui/icons-material/Close";
import InputAdornment from "@mui/material/InputAdornment";
import IconButton from "@mui/material/IconButton";
export interface IMedAppFormField {
  name: string;
  label?: string;
  placeholder?: string;
  defaultValue?: string;
  childFields?: IMedAppFormField[];
  inputExtras?: any;
  type: React.InputHTMLAttributes<HTMLInputElement>["type"];
  variant?:
    | "autocomplete"
    | "select"
    | "check"
    | "radio"
    | "slider"
    | "divider"
    | "date-picker"
    | "multi-input-select"
    | "file";
  validate?: Function[];
  forcedValue?: boolean;
}

const MedAppField: React.FC<any> = (props: any) => {
  const {
    placeholder,
    input,
    meta: { touched, error },
    label,
    inputExtras: others,
    forcedValue = false,

    defaultValue,
  } = props;

  useEffect(() => {
    if (defaultValue) {
      input.onChange(defaultValue);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [defaultValue]);
  return (
    <TextField
      {...input}
      label={label}
      defaultValue={"defaultValue"}
      {...(forcedValue && !!defaultValue && { value: defaultValue })}
      placeholder={placeholder}
      helperText={error}
      error={!!error && touched}
      sx={{
        width: "100%",
      }}
      {...others}
    />
  );
};

const MedAppFileField: React.FC<any> = (props: any) => {
  const {

    input,
    meta: { touched, error },
    label,
    inputExtras: others,


    defaultValue,
  } = props;

  useEffect(() => {
    if (defaultValue) {
      input.onChange(defaultValue);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [defaultValue]);
  return (
    <OutlinedInput
      type={"file"}
      label={label}
      
      
      inputProps={{
        accept: "image/*",
        
      }}
      onChange={(e: any) => {
        let f = e.target.files[0];
        input.onChange(f);
      }}
      endAdornment={
        <InputAdornment position="end">
          <IconButton
            onClick={() => {
              input.onChange(null);
            }}
          >
            <CloseIcon />
          </IconButton>
        </InputAdornment>
      }
    />

    // <TextField

    //   {...input}
    //   label={label}
    //   type="file"

    //   placeholder={placeholder}
    //     helperText={error}
    //     error={!!error && touched}
    //     sx={{
    //         width: '100%',

    //     }}
    //     {...others}

    // />
  );
};

const MedAppSelect: React.FC<any> = ({
  items,
  disabled,
  input,
  label,
  meta: { touched, error },
  defaultValue,
}) => {
  return (
    <>
      <InputLabel id={"id-" + input.name}>{label}</InputLabel>

      <Select
        name={input.name}
        defaultValue={defaultValue}
        onChange={(e) => {
          input.onChange(e.target.value);
        }}
        sx={{
          width: "100%",
        }}
      >
        {items.map((s: any, index: any) => (
          <MenuItem key={`${input.name}-item-${index}`} value={s.value}>
            {s.label}
          </MenuItem>
        ))}
      </Select>
    </>
  );
};

const MedAppAutoComplete: React.FC<any> = ({
  items,
  disabled,
  input,
  name,
  label,
  meta: { touched, error },
  defaultValue,
}) => {
  return (
    <Autocomplete
      disabled={disabled}
      options={items}
      autoComplete
      sx={{
        width: "100%",
      }}
      defaultValue={defaultValue}
      getOptionLabel={(option) => option.label}
      renderInput={(params) => (
        <TextField
          {...params}
          name={name}
          helperText={error}
          error={!!error && touched}
          {...input}
          label={label}
        />
      )}
    />
  );
};

const buildField = (field: IMedAppFormField & { isChild: boolean }) => {
  if (!field.variant) {
    return (
      <Field
        validate={field.validate}
        name={field.name}
        defaultValue={field.defaultValue}
        label={field.label}
        type={field.type}
        placeholder={field.placeholder}
        inputExtras={field.inputExtras}
        isChild={field.isChild}
        component={MedAppField}
      />
    );
  }
  let component: React.ReactNode;
  switch (field.variant) {
    case "select":
      const items = field.inputExtras! as Array<{
        label: string;
        value: string;
      }>;
      component = (
        <Field
          defaultValue={field.defaultValue}
          items={items}
          validate={field.validate}
          name={field.name}
          label={field.label}
          component={MedAppSelect}
        />
      );
      break;
    case "autocomplete":
      const items2 = field.inputExtras! as Array<{
        label: string;
        value: string;
      }>;
      component = (
        <Field
          defaultValue={field.defaultValue}
          items={items2}
          validate={field.validate}
          name={field.name}
          label={field.label}
          component={MedAppAutoComplete}
        />
      );
      break;
    case "date-picker":
      component = (
        <Field
          defaultValue={field.defaultValue}
          validate={field.validate}
          name={field.name}
          label={field.label}
          component={DatePickerWrapper}
        />
      );
      break;
    case "multi-input-select":
      component = (
        <Field
          validate={field.validate}
          name={field.name}
          defaultValue={field.defaultValue}
          label={field.label}
          type={field.type}
          placeholder={field.placeholder}
          inputExtras={field.inputExtras}
          component={MultiInputChip}
        />
      );

      break;

    case "file":
      component = (
        <Field
          type={field.type}
          validate={field.validate}
          name={field.name}
          label={field.label}
          placeholder={field.placeholder}
          inputExtras={field.inputExtras}
          isChild={true}
          component={MedAppFileField}
        />
      );
      break;
    default:
      component = (
        <Field
          type={field.type}
          defaultValue={field.defaultValue}
          validate={field.validate}
          name={field.name}
          label={field.label}
          placeholder={field.placeholder}
          inputExtras={field.inputExtras}
          isChild={true}
          component={MedAppField}
        />
      );
      break;
  }
  return component;
};

const getField = (
  field: IMedAppFormField,
  isChild = false,
  key: string | undefined = undefined
) => {
  if (field.childFields) {
    return (
      <>
        <Typography noWrap fontWeight={700} marginY={1}>
          {field.label}
        </Typography>

        <FormControl
          fullWidth
          sx={{
            display: "block",
            padding: "10px 0",
            marginBottom: "2px",
          }}
          key={key}
        >
          <FormSection container spacing={2} component={Grid} name={field.name}>
            {field.childFields.map((child, index) => (
              <Grid item xs={6} key={field.name + "child-" + index}>
                {getField(child, true)}
              </Grid>
            ))}
          </FormSection>
        </FormControl>
      </>
    );
  }
  if (field.variant === "divider") {
    return (
      <Box
        sx={{
          display: "block",
          padding: "10px 0",
          marginBottom: "2px",
        }}
        key={key}
      >
        <Divider />
      </Box>
    );
  }
  if (isChild) {
    return buildField({ ...field, isChild: true });
  }

  return (
    <FormControl
      fullWidth
      sx={{
        display: "block",
        padding: "10px 0",
        marginBottom: "2px",
      }}
      key={key}
    >
      {buildField({ ...field, isChild: false })}
    </FormControl>
  );
};

const FormBuilder: React.FC<{ fields: IMedAppFormField[]; name: string }> = ({
  fields,
  name,
}) => {
  return <>{fields.map((f, i) => getField(f, false, name + "child-" + i))}</>;
};

export default FormBuilder;
